export const LABEL_FROM = 'С';
export const LABEL_TO = 'По';
export const DISPLAY_FORMAT = 'dd.MM.yyyy';
